export default "__VITE_ASSET__f3c80bf7__"